module.exports = __webpack_public_path__ + "img/water.8498c186.png";